import React, { useEffect } from "react";
import UserService from "../../utils/keycloak.service.js";
import LoadingIcon from "../custom/inputs/ERPSLoadingIcon.js";
import { ResponsiveBox } from "../primitives";

export default function KcRedirect(props) {
  useEffect(() => {
    UserService.initKeycloak(props).then(() => {
      if (!UserService.isLoggedIn()) {
        UserService.doLogin();
      }
    });
  }, []);
  return (
    <ResponsiveBox textAlign={"center"} mt={30}>
      <LoadingIcon />
    </ResponsiveBox>
  );
}
